import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const DirectorRegistered = () => {
  const navigate = useNavigate();
  const { entityid } = useParams();

  const closeWizard = () => {
    navigate(`/entity/${entityid}/directors`);
  };

  const handleNewAppointment = () => {
    window.location.reload();
  };

  return (
    <div>
      <div className="formgrid grid flex justify-content-center align-item-center">
        <div className="no-key-container">
          <div className="duotone-container">
            <svg
              width="64"
              height="65"
              viewBox="0 0 64 65"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M33.625 0.875L57.125 10.875C59.875 12.125 62 14.75 62 18C61.875 30.5 56.75 53.125 35.25 63.5C33.125 64.5 30.75 64.5 28.625 63.5C7.125 53.125 2 30.5 2 18C1.875 14.75 4 12.125 6.75 10.875L30.25 0.875C30.75 0.625 31.375 0.5 32 0.5C32.5 0.5 33.125 0.625 33.625 0.875ZM46.125 26.625H46C47.25 25.5 47.25 23.625 46 22.375C44.875 21.25 43 21.25 41.875 22.375L28 36.375L22.125 30.5C20.875 29.25 19 29.25 17.875 30.5C16.625 31.625 16.625 33.5 17.875 34.625L25.875 42.625C27 43.875 28.875 43.875 30.125 42.625L46.125 26.625Z"
                fill="#188A42"
              />
              <path
                opacity="0.4"
                d="M33.625 0.875L57.125 10.875C59.875 12.125 62 14.75 62 18C61.875 30.5 56.75 53.125 35.25 63.5C33.125 64.5 30.75 64.5 28.625 63.5C7.125 53.125 2 30.5 2 18C1.875 14.75 4 12.125 6.75 10.875L30.25 0.875C30.75 0.625 31.375 0.5 32 0.5C32.5 0.5 33.125 0.625 33.625 0.875ZM46.125 26.625H46C47.25 25.5 47.25 23.625 46 22.375C44.875 21.25 43 21.25 41.875 22.375L28 36.375L22.125 30.5C20.875 29.25 19 29.25 17.875 30.5C16.625 31.625 16.625 33.5 17.875 34.625L25.875 42.625C27 43.875 28.875 43.875 30.125 42.625L46.125 26.625Z"
                fill="#188A42"
              />
            </svg>
          </div>
          <div className="no-key-align">
            <p className="no-key-personnel mb-2">Director registered</p>
            <p className="no-key-personnel-para">
              Your appointment has been created.
            </p>
          </div>
          <button className="add-new-contact" onClick={handleNewAppointment}>
            {" "}
            Add New Appointment <span className="pi pi-plus ml-2"></span>
          </button>
          <button
            type="button"
            className="cancel-btns mt-3"
            onClick={closeWizard}
          >
            Close Wizard
          </button>
        </div>
      </div>
    </div>
  );
};

export default DirectorRegistered;
